var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 16.4583H6.08341C2.40841 16.4583 1.29175 15.3416 1.29175 11.6666V8.33329C1.29175 4.65829 2.40841 3.54163 6.08341 3.54163H11.0834C14.7584 3.54163 15.8751 4.65829 15.8751 8.33329V11.6666C15.8751 15.3416 14.7584 16.4583 11.0834 16.4583ZM6.08341 4.79163C3.10008 4.79163 2.54175 5.35829 2.54175 8.33329V11.6666C2.54175 14.6416 3.10008 15.2083 6.08341 15.2083H11.0834C14.0667 15.2083 14.6251 14.6416 14.6251 11.6666V8.33329C14.6251 5.35829 14.0667 4.79163 11.0834 4.79163H6.08341Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 12.7083C16.9916 12.7083 16.7083 12.425 16.7083 12.0833C16.7083 11.7416 16.9916 11.4583 17.3333 11.4583C17.8249 11.4583 17.9333 11.3833 17.9416 11.3833C17.9583 11.3333 17.9583 11.0416 17.9583 10.8333V9.16663C17.9583 8.95829 17.9583 8.67496 17.9249 8.59996C17.9333 8.60829 17.7916 8.54163 17.3333 8.54163C16.9916 8.54163 16.7083 8.25829 16.7083 7.91663C16.7083 7.57496 16.9916 7.29163 17.3333 7.29163C19.0666 7.29163 19.2083 8.14163 19.2083 9.16663V10.8333C19.2083 11.8583 19.0666 12.7083 17.3333 12.7083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoom-icon.6a0d330f81a9c66b73fcc28c6dc7cffe.svg";
export { ForwardRef as ReactComponent };